
import React from 'react';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DatePillProps {
  date: string;
  className?: string;
}

const DatePill = ({ date, className }: DatePillProps) => {
  return (
    <span 
      className={cn(
        "text-xs px-3 py-1.5 rounded-full inline-flex items-center justify-center gap-1.5",
        "bg-gradient-to-r from-gray-50 to-white dark:from-slate-800 dark:to-slate-800/90",
        "border border-gray-200/50 dark:border-slate-700/30",
        "shadow-sm",
        className
      )}
    >
      <Clock size={12} className="text-muted-foreground" />
      {date}
    </span>
  );
};

export default DatePill;
